// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__17V95","selects":"Documents_selects__1t7oQ"};